import { createFileRoute } from '@tanstack/react-router'
import { useState, useEffect } from 'react'
import DialogPageComponent from '@/components/DialogPageComponent'
import WebcamSelector from '@/components/WebcamSelector'
import WebcamPreview from '@/components/WebcamPreview'
import FeatureAlerts from '@/components/FeatureAlerts'
// import { useVideoCapture } from '@/hooks/useVideoCapture'
import { useFeatureSupport } from '@/hooks/useFeatureSupport'
import { useWebcamConfig } from '@/hooks/useWebcamConfig'
import useNewSlideDetector from '@/hooks/useNewSlideDetector'
import { SimpleButton } from '@unwrittenmedia/simple-components'
import CaptureComponent from '@/components/CaptureComponent'

export const Route = createFileRoute('/quick/start')({
  component: QuickStart,
})

function QuickStart() {
  const [roomCode, setRoomCode] = useState('')
  const [roomPassword, setRoomPassword] = useState('')
  
  // Use webcam configuration from context instead of local state
  const { config } = useWebcamConfig()
  const selectedWebcam = config.webcamDeviceId || ''
  
  const { alerts, isSupported, checkFeatures } = useFeatureSupport()

  useNewSlideDetector();

  // Re-check features when video element becomes available
  useEffect(() => {
    checkFeatures()
  }, [checkFeatures])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Handle form submission
    console.log({ roomCode, roomPassword, selectedWebcam })
  }

  return (<main>
            <CaptureComponent />
    <DialogPageComponent>
      <h1 className="text-2xl font-bold mb-6">Quick Start</h1>
      
      <FeatureAlerts alerts={alerts} />
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="roomCode" className="block text-sm font-medium text-gray-700 dark:text-mist-300 mb-1">
            Room Code
          </label>
          <input
            type="text"
            id="roomCode"
            value={roomCode}
            onChange={(e) => setRoomCode(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-mist-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Enter room code"
            required
          />
        </div>

        <div>
          <label htmlFor="roomPassword" className="block text-sm font-medium text-gray-700 dark:text-mist-300 mb-1">
            Room Password
          </label>
          <input
            type="password"
            id="roomPassword"
            value={roomPassword}
            onChange={(e) => setRoomPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-mist-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Enter room password"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-mist-300 mb-1">
            Webcam
          </label>
          <WebcamSelector />
        </div>

        <WebcamPreview selectedWebcam={selectedWebcam} />


        {/* {error && (
          <div className="p-4 bg-red-50 rounded-lg">
            <div className="text-red-600 text-sm">{error}</div>
          </div>
        )} */}

        <SimpleButton
          type="submit"
          className="w-full"
          disabled={!selectedWebcam || !isSupported}
          color="info"
          size="md"
        >
          {!isSupported 
            ? 'Unsupported Browser' 
            : 'Start Session'}
        </SimpleButton>
      </form>
    </DialogPageComponent>
  </main>);
}
